import { render, staticRenderFns } from "./municipalities.vue?vue&type=template&id=5b4004a4&scoped=true&"
import script from "./municipalities.vue?vue&type=script&lang=ts&"
export * from "./municipalities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4004a4",
  null
  
)

export default component.exports